/*
 * Gemeinsame Domain-Typen (frameworkfrei, kein Import von Browser-APIs)
 */

// ─── Patienten ───────────────────────────────────────────────────────────────

export type PatientType = "privat" | "kasse";

export interface Patient {
  id: string;
  tenant_id: string;
  salutation: string | null;
  first_name: string;
  last_name: string;
  company_name: string | null;
  customer_number: string | null;
  birth_date: string | null;
  street: string | null;
  zip: string | null;
  city: string | null;
  phone: string | null;
  email: string | null;
  type: PatientType;
  archived_at: string | null;
  created_at: string;
  updated_at: string;
}

export type Customer = Patient;

export interface CatalogItem {
  id: string;
  number: string;
  name: string;
  long_description: string | null;
  factor: number;
  unit_price_cent: number;
  catalog_type: string;
  active: number;
}

export interface ClinicalNote {
  id: string;
  patient_id: string;
  noted_at: string;
  title: string | null;
  content: string;
}

// ─── Rechnungen ──────────────────────────────────────────────────────────────

export type InvoiceStatus =
  | "entwurf"
  | "finalisiert"
  | "versendet"
  | "teilbezahlt"
  | "bezahlt"
  | "ueberfaellig"
  | "gemahnt"
  | "storniert"
  | "abgeschrieben";

export interface Invoice {
  id: string;
  tenant_id: string;
  invoice_number: string;
  invoice_date: string;
  due_date: string;
  status: InvoiceStatus;
  total_cent: number;
  finalized_at: string | null;
  patient_snapshot: string; // JSON
  practice_snapshot: string; // JSON
  r2_pdf_key: string | null;
  created_at: string;
  updated_at: string;
}

// ─── Leistungen ──────────────────────────────────────────────────────────────

export interface Service {
  id: string;
  tenant_id: string;
  patient_id: string;
  catalog_item_id: string | null;
  performed_at: string;
  item_number: string;
  item_name: string;
  factor: number;
  unit_price_cent: number;
  quantity: number;
  total_cent: number;
  notes: string | null;
  invoice_id: string | null;
}

export function customerName(customer: Pick<Customer, "company_name" | "first_name" | "last_name">) {
  return customer.company_name || `${customer.first_name} ${customer.last_name}`.trim();
}

// ─── Berechnungen ────────────────────────────────────────────────────────────

/** Offener Betrag in Cent */
export function outstandingCent(
  totalCent: number,
  payments: { amount_cent: number }[],
): number {
  const paid = payments.reduce((sum, p) => sum + p.amount_cent, 0);
  return Math.max(0, totalCent - paid);
}

/** Formatierung Cent → EUR-String */
export function formatEur(cent: number): string {
  return (cent / 100).toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
  });
}
